import {browserHistory} from "react-router";
import {Component} from "react";
import {AccordionForm, BoxedField, BoxedSelectList} from "..";
import I18n from "lib/i18n/i18n";
import * as React from "react";
import {preloadImages} from 'helpers/ApplicationHelper';
import {DiamondClarity, DiamondColor, ItemTypes} from "../../../constants/itemDetails";

let initialized = false;
class SubmitNecklace extends Component {

    constructor(props) {
        super(props)

        if ( !initialized ) {
            this.init()
            initialized = true
        }

        this.state = {
            options:[]
        }
        this.state.options = this.getOptions()

        preloadImages(images)

        this.submitNecklace = this.submitNecklace.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);
        this.getTranslatedValue = this.getTranslatedValue.bind(this);
    }

    init() {
        let styles = {...CENTER_STONE_STYLES,  ...MULTIPLE_DIAMONDS_STYLES};
        for ( let style in styles ) {
            styleOptions.push({name: style, text: styles[style], img: `${NECKLACE_STYLE_PREFIX}/${style}.svg`, imgSelected: `${NECKLACE_STYLE_PREFIX}/${style}_white.svg`});
        }

        let metalTypes = I18n.getVar("submitForm::necklace::metalTypes")
        for ( let type in metalTypes ) {
            metalTypeOptions.push({name: type, text: metalTypes[type]});
        }

        let shapes = I18n.getVar("submitForm::necklace::shapes");
        for ( let shape in shapes ) {
            shapeOptions.push({name: shape, text: shapes[shape], img: `${DIAMOND_SHAPE_PREFIX}/${shape}.svg`, imgSelected: `${DIAMOND_SHAPE_PREFIX}/${shape}_white.svg`});
        }
        let colors = [ 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-Z', I18n.getString("submitForm::necklace::colors::fancy") ]
        for ( let color in colors ) {
            colorOptions.push({name: colors[color], text: colors[color]});
        }

        let clarityTypes = I18n.getVar("submitForm::necklace::clarityTypes");
        for ( let clarity in clarityTypes ) {
            clarityOptions.push({name: clarity, text: clarityTypes[clarity], img: `${CLARITY_PREFIX}/${clarity}_black.svg`, imgSelected: `${CLARITY_PREFIX}/${clarity}_white.svg`});
        }

        let brands = I18n.getVar("submitForm::necklace::brands");
        for ( let brand in brands ) {
            brandOptions.push({name: brand, text: brands[brand], img: `${BRAND_PREFIX}/${brand}-black.png`, imgSelected: `${BRAND_PREFIX}/${brand}-white.png`});
        }

    }

    getTranslatedValue(propName, propValue){
        if(!propValue){
            let field = this.state.options.find(o => o.name === propName || o.full_name === propName);
            if(!field.isRequired){
                propValue = field.defaultValue
            }
        }
        // relevant when carat weight option is like 14k.
        let value = propName === 'jewelry_metal_type' && propValue.match(/^\d{1,2}k/)?  `${propValue.split(' ')[0]} gold` :  propValue;
        value = value ? value.replace(/ |-/, "_").toLowerCase() : value;
        return isNaN(value) ? `${propName}_${value}`: value;
    }

    submitNecklace(details) {
        let params = {
            item_type: necklaceParams.itemType,
            returnToSite: true,
            seller_item: {
                item_type_id: necklaceParams.id,
                desc: necklaceParams.name,
                subsets: {
                    1: {
                        properties_set:{
                            item_type: necklaceParams.id
                        }
                    }
                }
            }
        }

        const formInput = {
            itemType:ItemTypes.Necklace,
            style: details.jewelry_style_necklace.toLowerCase(),
            metalType: details.jewelry_metal_type.toLowerCase(),
            caratWeight: details.diamond_carat_weight && parseFloat(details.diamond_carat_weight),
            caratWeightTotal: details.diamond_total_carat_weight && parseFloat(details.diamond_total_carat_weight),
            shape: details.diamond_shape && details.diamond_shape.toLowerCase(),
            color: (details.diamond_color && details.diamond_color.toLowerCase()) || DiamondColor.NotSure,
            clarity: (details.diamond_clarity && details.diamond_clarity.toLowerCase()) || DiamondClarity.NotSure,
            brand: details.jewelry_brand && details.jewelry_brand.toLowerCase(),
            numDiamonds: details.diamond_number_of_stones && parseInt(details.diamond_number_of_stones),
            submitTimestamp: new Date().toISOString()
        }

        for ( let key in details ){
            let propertyIndex;
            let name = key;
            if ( key.startsWith('jewelry') ) {
                propertyIndex = 1;
            }
            else{
                if( !Object.values(MULTIPLE_DIAMONDS_STYLES).includes(details.jewelry_style_necklace) ) {
                    propertyIndex = 3;
                }
                else {
                    propertyIndex = 2;
                    let field = this.state.options.find(o => o.name === key);
                    if(field.full_name){
                        name = field.full_name;
                    }
                }
            }

            if ( !params.seller_item.subsets[propertyIndex] ) {
                params.seller_item.subsets[propertyIndex]= {
                    properties_set:{}
                };
            }
            params.seller_item.subsets[propertyIndex].type = necklaceParams.systemNames[propertyIndex];
            params.seller_item.subsets[propertyIndex].properties_set[name] = this.getTranslatedValue(name, details[key]);
        }

        if (!this.props.Session.isLoggedIn) {
            browserHistory.push('/register');
        } else {
            this.setState({submitFormInProcess: true});
        }

        this.props.newPendingItem(this.props.params, params, this.props.Session.isLoggedIn, formInput);
    }

    getOptions() {
        let caratFields = [ formOptions.caratWeight ];
        let styleName = this.state[formOptions.style.name];
        if ( styleName && Object.values(MULTIPLE_DIAMONDS_STYLES).includes(styleName) ) {
            caratFields = [
                formOptions.numberOfDiamonds,
                formOptions.totalCaratWeight
            ]
        }

        return [
            formOptions.style,
            formOptions.metalType,
            ...caratFields,
            formOptions.shape,
            formOptions.color,
            formOptions.clarity,
            formOptions.brand,
        ];
    }

    onValueChanged(key, value, callback) {
        this.setState({[key]:value},() => {
            if ( key === formOptions.style.name ) {
                this.setState({options: this.getOptions()}, () => {
                    callback();
                })
            }
            else {
                callback();
            }
        })
    }

    render() {
        return <AccordionForm onSubmit={this.submitNecklace} {...this.state}
                              onValueChanged={this.onValueChanged}
                              title={I18n.getString("submitForm::necklace::title")}
                              name={"submit-necklace"}
                              options={this.state.options}
                              location={this.props.location}/>
    }
}

const NECKLACE_STYLE_PREFIX = 'common/necklace/styles';
const DIAMOND_SHAPE_PREFIX = 'common/necklace/shapes';
const BRAND_PREFIX = 'brands/desktop';
const CLARITY_PREFIX = 'common/diamond_clarity';
const CENTER_STONE_STYLES = I18n.getVar("submitForm::necklace::styles::centerStone")
const MULTIPLE_DIAMONDS_STYLES = I18n.getVar("submitForm::necklace::styles::multipleDiamonds")
const necklaceParams = {
    id: 1,
    name: "Jewelry",
    itemType: "Necklaces",
    systemNames: ["", "jewelry_necklaces","diamond_minor_stone_batch", "diamond_center_stone"]
}

let styleOptions = [], metalTypeOptions = [], shapeOptions = [], colorOptions = [], clarityOptions = [], brandOptions = [];
const formOptions = {
    style:{
        name: "jewelry_style_necklace",
        type: BoxedSelectList,
        options: styleOptions,
        hasOther: true,
        label: I18n.getString("submitForm::necklace::fields::style::label"),
        addClass: "textInBox",
        showName: true,
        isRequired: true
    },
    metalType:{
        name: 'jewelry_metal_type',
        type: BoxedSelectList,
        options: metalTypeOptions,
        hasOther: true,
        label: I18n.getString("submitForm::necklace::fields::metalType::label"),
        addClass: "oneline",
        isRequired: true
    },
    caratWeight:{
        name: 'diamond_carat_weight',
        type: BoxedField,
        label: I18n.getString("submitForm::necklace::fields::caratWeight::label"),
        placeholder: I18n.getString("submitForm::necklace::fields::caratWeight::placeholder"),
        note: I18n.getString("submitForm::necklace::fields::caratWeight::note"),
        isRequired: true,
        dependsOn: 'jewelry_style_necklace',
        inputType: 'number'
    },
    numberOfDiamonds:{
        name: 'diamond_number_of_stones',
        type: BoxedField,
        label: I18n.getString("submitForm::necklace::fields::numberOfDiamonds::label"),
        placeholder: I18n.getString("submitForm::necklace::fields::numberOfDiamonds::placeholder"),
        note: I18n.getString("submitForm::necklace::fields::numberOfDiamonds::note"),
        isRequired: true,
        dependsOn: 'jewelry_style_necklace',
        inputType: 'number'
    },
    totalCaratWeight:{
        name: 'diamond_total_carat_weight',
        type: BoxedField,
        label: I18n.getString("submitForm::necklace::fields::totalCaratWeight::label"),
        placeholder: I18n.getString("submitForm::necklace::fields::totalCaratWeight::placeholder"),
        note: I18n.getString("submitForm::necklace::fields::totalCaratWeight::note"),
        isRequired: true,
        dependsOn: 'jewelry_style_necklace',
        inputType: 'number'
    },
    shape:{
        name: "diamond_shape",
        type: BoxedSelectList,
        options: shapeOptions,
        hasOther: true,
        label: I18n.getString("submitForm::necklace::fields::shape::label"),
        addClass: "textInBox",
        showName: true,
        isRequired: true
    },
    color:{
        name: "diamond_color",
        type: BoxedSelectList,
        options: colorOptions,
        label: I18n.getString("submitForm::necklace::fields::color::label"),
        addClass: 'small-box',
        note: I18n.getString("submitForm::necklace::fields::color::note"),
        isRequired: false,
        hasNotSure: true,
        full_name: 'diamond_average_color_grade',
        defaultValue: 'Not Sure'
    },
    clarity:{
        name: 'diamond_clarity',
        type: BoxedSelectList,
        options: clarityOptions,
        label: I18n.getString("submitForm::necklace::fields::clarity::label"),
        note: I18n.getString("submitForm::necklace::fields::clarity::note"),
        addClass: "textInBox",
        showName: true,
        isRequired: false,
        hasNotSure: true,
        full_name: 'diamond_average_clarity_grade',
        defaultValue: 'Not Sure'
    },
    brand:{
        name: 'jewelry_brand',
        type: BoxedSelectList,
        options: brandOptions,
        hasOther: true,
        label: I18n.getString("submitForm::necklace::fields::brand::label"),
        isRequired: false,
        defaultValue: null
    }
};

const images = [
    `${DIAMOND_SHAPE_PREFIX}/round.svg`,
    `${DIAMOND_SHAPE_PREFIX}/round_white.svg`,
    `${DIAMOND_SHAPE_PREFIX}/oval.svg`,
    `${DIAMOND_SHAPE_PREFIX}/oval_white.svg`,
    `${DIAMOND_SHAPE_PREFIX}/cushion.svg`,
    `${DIAMOND_SHAPE_PREFIX}/cushion_white.svg`,
    `${DIAMOND_SHAPE_PREFIX}/pear.svg`,
    `${DIAMOND_SHAPE_PREFIX}/pear_white.svg`,
    `${DIAMOND_SHAPE_PREFIX}/emerald.svg`,
    `${DIAMOND_SHAPE_PREFIX}/emerald_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/drop.svg`,
    `${NECKLACE_STYLE_PREFIX}/drop_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/pendant.svg`,
    `${NECKLACE_STYLE_PREFIX}/pendant_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/link.svg`,
    `${NECKLACE_STYLE_PREFIX}/link_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/choker.svg`,
    `${NECKLACE_STYLE_PREFIX}/choker_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/collar.svg`,
    `${NECKLACE_STYLE_PREFIX}/collar_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/lariat.svg`,
    `${NECKLACE_STYLE_PREFIX}/lariat_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/riviera.svg`,
    `${NECKLACE_STYLE_PREFIX}/riviera_white.svg`,
    `${NECKLACE_STYLE_PREFIX}/station.svg`,
    `${NECKLACE_STYLE_PREFIX}/station_white.svg`,
    `${BRAND_PREFIX}/tiffany-black.png`,
    `${BRAND_PREFIX}/tiffany-white.png`,
    `${BRAND_PREFIX}/cartier-black.png`,
    `${BRAND_PREFIX}/cartier-white.png`,
    `${BRAND_PREFIX}/van-cleef-black.png`,
    `${BRAND_PREFIX}/van-cleef-white.png`,
    `${BRAND_PREFIX}/harry-black.png`,
    `${BRAND_PREFIX}/harry-white.png`,
    `${BRAND_PREFIX}/david-yurman-black.png`,
    `${BRAND_PREFIX}/david-yurman-white.png`,
    `${CLARITY_PREFIX}/fl_black.svg`,
    `${CLARITY_PREFIX}/fl_white.svg`,
    `${CLARITY_PREFIX}/if_black.svg`,
    `${CLARITY_PREFIX}/if_white.svg`,
    `${CLARITY_PREFIX}/vvs1_black.svg`,
    `${CLARITY_PREFIX}/vvs1_white.svg`,
    `${CLARITY_PREFIX}/vvs2_black.svg`,
    `${CLARITY_PREFIX}/vvs2_white.svg`,
    `${CLARITY_PREFIX}/vs1_black.svg`,
    `${CLARITY_PREFIX}/vs1_white.svg`,
    `${CLARITY_PREFIX}/vs2_black.svg`,
    `${CLARITY_PREFIX}/vs2_white.svg`,
    `${CLARITY_PREFIX}/si1_black.svg`,
    `${CLARITY_PREFIX}/si1_white.svg`,
    `${CLARITY_PREFIX}/si2_black.svg`,
    `${CLARITY_PREFIX}/si2_white.svg`,
    `${CLARITY_PREFIX}/i1_black.svg`,
    `${CLARITY_PREFIX}/i1_white.svg`,
    `${CLARITY_PREFIX}/i2_black.svg`,
    `${CLARITY_PREFIX}/i2_white.svg`,
    `${CLARITY_PREFIX}/i3_black.svg`,
    `${CLARITY_PREFIX}/i3_white.svg`,
];



export {SubmitNecklace};


